module.exports = __webpack_public_path__ + "img/img-8.76781f59.png";